import {selector} from "./selector";
import { crud } from '../../../../app/crud';

let emailCodeTimerActive = false; // ✅ FLAG

const toggleCustomerType = function (e) {
    let customerType = parseInt($(e.target).val());

    if (customerType === 1) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').show();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').hide(); 
        for (const key in selector.form.businessForeign) $(selector.form.businessForeign[key]).parent('.form-group').hide();
    } else if (customerType === 2) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').hide();
        for (const key in selector.form.businessForeign) $(selector.form.businessForeign[key]).parent('.form-group').hide();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').show();
    } else if (customerType === 3) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').hide();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').hide();
        for (const key in selector.form.businessForeign) $(selector.form.businessForeign[key]).parent('.form-group').show();
    } else {
        console.error('Undefined customer type');
    }
};

const isValidEmail = function (email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

const toggleEmailVerificationUI = function () {
    if (emailCodeTimerActive) {
        return;
    }

    const emailVal = $(selector.email).val();

    if (isValidEmail(emailVal)) {
        $(selector.emailSendCodeBtn).prop('disabled', false);
        $(selector.emailCode).prop('disabled', false);
    } else {
        $(selector.emailSendCodeBtn).prop('disabled', true);
        $(selector.emailCode).prop('disabled', true);
    }
};

const sendVerificationCode = function () {
    const email = $(selector.email).val();
    const url = '/obo/tag-registracija/send-verification-code';

    if (!isValidEmail(email)) {
        return;
    }

    const $btn = $(selector.emailSendCodeBtn);

    const formData = new FormData();
    formData.append('email', email);

    $btn.prop('disabled', true);

    crud.create(url, formData)
        .done(function (response) {
            const status = Number(response.status || 0);
            const hasErrorMessage = !!(response.message && response.message.trim() !== '');
            const isSuccess = status >= 200 && status < 300 && !hasErrorMessage;

            if (!isSuccess) {
                if (hasErrorMessage) {
                    showEmailError(response.message);
                }
                $btn.prop('disabled', false);
                return;
            }

            showEmailError('');
            startSendCodeTimer(60);
            $(selector.emailCode).prop('disabled', false).focus();
        })
        .fail(function (xhr) {
            showEmailError(xhr.responseJSON?.message);
            $btn.prop('disabled', false);
        });

};
const startSendCodeTimer = function (seconds) {
    let remaining = seconds;
    emailCodeTimerActive = true;

    const $btn = $(selector.emailSendCodeBtn);
    const defaultText = $btn.data('text-default');
    const timerText = $btn.data('text-timer');

    $btn
        .prop('disabled', true)
        .text(
            timerText.replace(':seconds', remaining)
        );

    const interval = setInterval(function () {
        remaining--;

        if (remaining > 0) {
            $btn.text(
                timerText.replace(':seconds', remaining)
            );
        } else {
            clearInterval(interval);
            emailCodeTimerActive = false;

            $btn
                .text(defaultText)
                .prop('disabled', false);
        }
    }, 1000);
};

const showEmailError = function (message) {
    const $input = $('#cardholder_email');
    const $inputGroup = $input.closest('.input-group');
    let $error = $inputGroup.next('.invalid-feedback');

    if ($error.length === 0) {
        $error = $('<div class="invalid-feedback d-block"></div>');
        $inputGroup.after($error);
    }

    if (!message || message.trim() === '') {
        $input.removeClass('is-invalid');
        $error.text('').hide();
        return;
    }
    $input.addClass('is-invalid');
    $error.text(message).show();
};

export {
    toggleCustomerType,
    toggleEmailVerificationUI,
    sendVerificationCode
};
